module.exports = __webpack_public_path__ + "static/media/MBTA-Bus-2.d5b17c17.jpg";